import React from "react";
import { useNavigate } from "react-router-dom";
import { IconCheck } from "../../../assets/svgs-index";
import { PasswordRecoveryLabels } from "../../../assets/labels/labels";

const PasswordRecoverySent: React.FC<any> = () => {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <div className="grey-box-container align-center mt-6 py-4 px-6 w-100">
        <h3 className="text-center w-100">{PasswordRecoveryLabels.sentTitle}</h3>
        <div className="text-center message-container mt-4">{PasswordRecoveryLabels.sentMessage}</div>
        <div className="check-icon-container mt-5 mb-2">
            <img src={IconCheck} alt="icon-check" />
          </div>
        <div className="link-container mt-4 text-center" onClick={() => navigate("/")}>
          {PasswordRecoveryLabels.sentLinkMessage}
        </div>
      </div>
    </React.Fragment>
  );
};

export default PasswordRecoverySent;
